import {Injectable} from '@angular/core';
import {interval} from "rxjs";
import {SwUpdate} from "@angular/service-worker";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class ApplicationUpdateService {

  constructor(public updates: SwUpdate, private router: Router) {
    if (updates.isEnabled) {
      interval(6 * 60 * 60).subscribe(() => updates.checkForUpdate()
      .then(() => {
        console.log('checking for updates');
        this.checkForUpdates();
      }));
    }
  }

  public checkForUpdates(): void {
    this.updates.versionUpdates.subscribe((hasUpdate) => {
      if (hasUpdate.type === 'VERSION_READY') {
        console.log('update to new version');
        this.updateToNewVersion();
      }
    });
  }

  private updateToNewVersion(): void {
    if (this.router.url.indexOf("signup") <= -1 || this.router.url.indexOf("reset") <= -1) {
      console.log('updating to new version');
      this.updates.activateUpdate().then(() => document.location.reload());
    }
  }
}
